import React, { useEffect, useRef, useState } from 'react'
import { useLocation } from '@reach/router'
import Countdown from 'react-countdown'
import { getQueryEventTracker } from '@helpers/helper.actions'
import { informCustomEvent } from '@helpers/helper.analytics'
import { ModuleActionProps } from 'types'
import { useCreateApplicationMutation as useSendTrackerEvent } from '@apis/mediacore/tracker'

const TopAlert = ({
  linkTo,
  linkTxt,
  textAlert,
  showOn,
  eventDate,
  utmValue,
  name,
  property,
  development,
  page,
  action,
}: ModuleActionProps) => {
  const location = useLocation()
  const pathname = location.pathname.replace('/', '')

  const [loaded, setIsLoad] = useState(false)
  const [closed, setClosed] = useState(() => false)
  const [sendTrackerEvent] = useSendTrackerEvent()
  const alertRef = useRef<HTMLDivElement>(null)

  // ─── Manejo del padding-top en body ────────────────────────────────────────
  // Cuando la alerta está visible, el body recibe un padding-top igual a su altura.
  // Así el header fixed no la tapa, sin tocar ningún componente de header.

  const applyBodyPadding = () => {
    const height = alertRef.current?.offsetHeight ?? 0
    // El header se empuja hacia abajo con top igual a la altura de la alerta
    document.getElementById('header')?.style.setProperty('top', `${height}px`)
    document.getElementById('dynamic_header')?.style.setProperty('top', `${height}px`)
  }

  const removeBodyPadding = () => {
    document.getElementById('header')?.style.removeProperty('top')
    document.getElementById('dynamic_header')?.style.removeProperty('top')
  }

  // Recalcular si cambia el tamaño de ventana
  useEffect(() => {
    window.addEventListener('resize', applyBodyPadding)
    return () => window.removeEventListener('resize', applyBodyPadding)
  }, [])

  // ─── Lógica original ───────────────────────────────────────────────────────

  useEffect(() => {
    if (closed) return // ← si ya fue cerrada, no hacer nada

    if (!closed) {
      if (checkPage()) {
        if (
          (action.section === 'Detalle de Emprendimiento' && development?.id) ||
          (action.section === 'Detalle de propiedad' && property?.id) ||
          (action.section !== 'Detalle de Emprendimiento' &&
            action.section !== 'Detalle de propiedad')
        ) {
          if (closed === false) {
            informCustomEvent(
              'SHOW_' +
                page.id +
                '_' +
                (property && action.section === 'Detalle de propiedad'
                  ? property.id.toString()
                  : development && action.section === 'Detalle de Emprendimiento'
                    ? development.id.toString()
                    : '0') +
                '_' +
                action.id,
            )
            sendTrackerEvent(
              getQueryEventTracker({
                page: page,
                action: action,
                type: 'SHOW',
                data_id: property
                  ? property.id.toString()
                  : development
                    ? development.id.toString()
                    : '0',
                url: location.href,
                extra_title:
                  action.section === 'Detalle de propiedad' && property
                    ? property?.address
                    : development && action.section === 'Detalle de Emprendimiento'
                      ? development.name
                      : '',
              }),
            )
            document.getElementById('top-alert-' + name)?.classList.add('animate-show')
            document.getElementById('dynamic_header')?.classList.toggle('top-custom')
            document.getElementById('header')?.classList.toggle('top-custom')

            // Aplicar padding al body una vez que la alerta animó
            setTimeout(() => {
              applyBodyPadding()
              setIsLoad(true)
            }, 1000)
          }
        }
      } else {
        setClosed(true)
        removeStyles()
      }
    }
  }, [pathname, showOn, property, development])

  useEffect(() => {
    if (loaded) {
      removeStyles()
    }
  }, [pathname])

  useEffect(() => {
    return () => {
      removeStyles() // 👈 se ejecuta cuando el componente se desmonta
    }
  }, [])

  useEffect(() => {
    if (closed) {
      removeStyles()
    }
  }, [closed])

  const rendererCtd = ({ days, hours, minutes, seconds }: any) => (
    <div className="counter d-flex">
      <span className="mx-2">
        <span className="date-val">{days}</span> DÍAS
      </span>
      <span className="me-2">
        <span className="date-val">{hours}</span> HS
      </span>
      <span className="me-2">
        <span className="date-val">{minutes}</span> MIN
      </span>
      <span className="me-2">
        <span className="date-val">{seconds}</span> SEG
      </span>
    </div>
  )

  const capitalizeFirst = (text: string) => text[0].toUpperCase() + text.slice(1, text.length)

  const checkPage = () => {
    return true
  }

  const removeStyles = (): void => {
    console.log('remuevo')
    document.getElementById('top-alert-' + name)?.classList.remove('animate-show')
    document.getElementById('header')?.classList.remove('top-custom')
    document.getElementById('dynamic_header')?.classList.remove('top-custom')
    removeBodyPadding()
  }

  if (!checkPage) {
    removeStyles()
  }

  return checkPage() ? (
    <div
      ref={alertRef}
      id={'top-alert-' + name}
      className={'custom-alert fade show ' + (showOn.toLowerCase() === 'inicio' ? 'isHome' : '')}
    >
      <div className="container-fluid">
        {eventDate && (
          <div className="counter-wrapper">
            Quedan
            <Countdown
              date={new Date(eventDate).getTime()}
              renderer={rendererCtd}
            />
          </div>
        )}
        {textAlert && (
          <div className={`text-content my-2`}>
            {eventDate ? ` ${textAlert}` : capitalizeFirst(textAlert)}
          </div>
        )}
        {linkTo && linkTxt && (
          <a
            href={linkTo + utmValue}
            onClick={() => {
              informCustomEvent(
                'PUSH_' +
                  page.id +
                  '_' +
                  (property && action.section === 'Detalle de propiedad'
                    ? property.id.toString()
                    : development && action.section === 'Detalle de Emprendimiento'
                      ? development.id.toString()
                      : '0') +
                  '_' +
                  action.id,
              )
              sendTrackerEvent(
                getQueryEventTracker({
                  page: page,
                  action: action,
                  type: 'PUSH',
                  data_id:
                    property && action.section === 'Detalle de propiedad'
                      ? property.id.toString()
                      : development && action.section === 'Detalle de Emprendimiento'
                        ? development.id.toString()
                        : '0',
                  url: location.href,
                  extra_title:
                    action.section === 'Detalle de propiedad' && property
                      ? property?.address
                      : development && action.section === 'Detalle de Emprendimiento'
                        ? development.name
                        : '',
                }),
              )
            }}
            className="btn-link"
            target="_blank"
          >
            {linkTxt}
          </a>
        )}
      </div>
      <i
        className="icon-plus"
        id="closeAlert"
        onClick={() => {
          sessionStorage.setItem('alert-closed-' + name, 'true')
          setClosed(true)
        }}
      ></i>
    </div>
  ) : (
    <div></div>
  )
}

export default TopAlert
